export interface SearchResult {
    title: string;
    excerpt: string;
    typeName: string;
    updateDate?: Date;
    publishDate?: string;
    startTime?: string;
    endTime?: string;
    url: string;
    iconId: string;
    displayName: string;
    score: number;
}

export class FilterItem {
    name: string;
    value: string[];
    id: number;
    hiddenregions: string[];

    constructor(id: number, name: string, value: string[], hiddenregions?: string[]) {
        this.id = id;
        this.name = name;
        this.value = value.map((x) => x.toLowerCase());
        if (hiddenregions !== undefined) {
            this.hiddenregions = hiddenregions;
        } else {
            this.hiddenregions = [];
        }
    }
}
